import vars from '../helpers';

let blogs;
let filter;
let filterOverlay;
let filterBurger;

if (document.querySelector('.blogs')) {
	blogs = document.querySelector('.blogs');
}

if (blogs) {
	filter = blogs.querySelector('.blogs-main__categories-mobile');
	filterOverlay = blogs.querySelector('.blogs-main__overlay');
	filterBurger = blogs.querySelector('.blogs-main__filter');
}

const filterActive = () => {
	filter.classList.add('flex');
	filterOverlay.classList.add('block');

	setTimeout(() => {
		filter.classList.add('active');
	}, 10);
};

const filterDeActive = () => {
	filter.classList.remove('active');

	setTimeout(() => {
		filter.classList.remove('flex');
		filterOverlay.classList.remove('block');
	}, 200);
};

const filterOpen = () => {
	if (vars.isDesktop()) {
		return;
	}

	if (filter.classList.contains('active')) {
		filterDeActive();
	} else {
		filterActive();
	}
};

const filterInit = () => {
	if (blogs) {
		filterBurger.addEventListener('click', () => {
			filterOpen();
		});

		filterOverlay.addEventListener('click', () => {
			filterOpen();
		});

		window.addEventListener('resize', () => {
			if (vars.isDesktop() && filter.classList.contains('active')) {
				filterDeActive();
			}
		});
	}
};

export default filterInit;
